import React, { useCallback, useEffect } from "react"
import { useAppDispatch } from "../../../store/hooks"
import { usePopoverShown } from "../../../utility/knowledgeBase/usePopoverShown"
import ArticleFilterPopover from "./ArticleFilterPopover"
import { ArticleFilterFormValues } from "../../../models/articleFilter"
import { setCurrentArticlesFilter, setKnowledgeBaseWorkMode } from "../../../store/knowledgeBase/slice"
import { KnowledgeBaseWorkMode } from "../../../models/knowledgeBase/workMode"

const ArticleFilterPopoverContainer: React.FC = () => {
    const dispatch = useAppDispatch()

    const { shown, showPopover, hidePopover } = usePopoverShown()

    const handleSubmit = useCallback(
        (values: ArticleFilterFormValues) => {
            dispatch(setCurrentArticlesFilter(values))
            dispatch(setKnowledgeBaseWorkMode(KnowledgeBaseWorkMode.Search))
            hidePopover()
        },
        [dispatch, hidePopover]
    )

    useEffect(() => {
        return () => {
            dispatch(setCurrentArticlesFilter({}))
            dispatch(setKnowledgeBaseWorkMode(KnowledgeBaseWorkMode.CatalogsView))
        }
    }, [])

    return <ArticleFilterPopover show={shown} onShow={showPopover} onCancel={hidePopover} onSubmit={handleSubmit} />
}

export default ArticleFilterPopoverContainer
